import React, { Component } from 'react';
import { View, Text, StyleSheet, Dimensions, ScrollView, TouchableOpacity, Image, FlatList} from 'react-native';

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

export default class EdeklaracjaScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <View style={styles.contener}>
          <View style={styles.panelBoczny}>
       
       </View>
          <View style={styles.contenerEdek}>
              <ScrollView>
          <View style={{marginVertical: 30}}>
              <View style={{flexDirection: 'row', justifyContent: 'center', marginVertical: 40}}>
              <Text style={{fontSize: 30, color: '#2fd756', fontWeight: '500', fontFamily: 'rubikRegular'}}>Czyste</Text>
              <Text style={{fontSize: 30, color: '#000000', fontWeight: '500', fontFamily: 'rubikRegular'}}>Miasto.pl </Text>
              </View>
              <Text style={{color: '#2fd756', fontFamily: 'rubikMedium', fontSize: 25, marginBottom: 10}}>E-Deklaracja</Text>
          <Text style={{color: 'black', fontFamily: 'rubikLight', fontSize: 15}}>Formularz nalezy wypełnić, następnie pobrać wydrukować, podpisać i dostarcztć do Urzędu Miasta</Text></View>
            <View>
                <Image style={{width: windowWidth*0.6, height: 600, resizeMode: 'contain'}} source={require('../assets/edek1.png')}/>
                <Image style={{width: windowWidth*0.6, height: 600, resizeMode: 'contain'}} source={require('../assets/edek2.png')}/>
                <Image style={{width: windowWidth*0.6, height: 700, resizeMode: 'contain'}} source={require('../assets/edek3.png')}/>
                <Image style={{width: windowWidth*0.6, height: 450, resizeMode: 'contain'}} source={require('../assets/edek4.png')}/>
                <Image style={{width: windowWidth*0.6, height: 700, resizeMode: 'contain'}} source={require('../assets/edek5.png')}/>
                <Image style={{width: windowWidth*0.6, height: 600, resizeMode: 'contain'}} source={require('../assets/edek6.png')}/>
                <Image style={{width: windowWidth*0.6, height: 600, resizeMode: 'contain'}} source={require('../assets/edek7.png')}/>
<View style={{flex:1, flexDirection: 'row-reverse', justifyContent: 'space-between'}}>
                <TouchableOpacity >
        <View style={{padding: 30, backgroundColor: '#2fd756', borderWidth:0, borderRadius: 15, marginVertical: 25,width: windowWidth*0.25, marginRight: 20, justifyContent: 'center', alignItems: 'center',shadowColor: "#000", alignSelf: 'flex-end',
            shadowOffset: {
	        width: 0,
	      height: 5,
          },
          shadowOpacity: 0.34,
        shadowRadius: 6.27,
          elevation: 10,  }}> 
            <Text style={{color: 'white', fontFamily: 'rubikLight', letterSpacing: 2, fontSize: 20, marginBottom: 5}}>Pobierz</Text>
            <Text style={{color: 'red', fontFamily: 'rubikLight', letterSpacing: 2, fontSize: 15}}>Wypełnij każde pole!</Text>

        </View>
</TouchableOpacity>
<TouchableOpacity onPress={() => this.props.navigation.navigate('user')}>
        <View style={{padding: 30, backgroundColor: '#2fd756', borderWidth:0, borderRadius: 15, marginVertical: 25,width: windowWidth*0.25, marginRight: 20, justifyContent: 'center', alignItems: 'center',shadowColor: "#000", alignSelf: 'flex-end',
            shadowOffset: {
	        width: 0,
	      height: 5,
          },
          shadowOpacity: 0.34,
        shadowRadius: 6.27,
          elevation: 10,  }}> 
            <Text style={{color: 'white', fontFamily: 'rubikLight', letterSpacing: 2, fontSize: 20, marginBottom: 5}}>Wróć do storny głównej</Text>
          

        </View>
</TouchableOpacity>
          </View> 
            </View>
            </ScrollView>
          </View>

      </View>
    );
  }
}
const styles = StyleSheet.create({
    contener: {
        flex:1,
        flexDirection: 'row',
        backgroundColor: '#2fd756'
    },
    contenerEdek: {
        width: windowWidth*0.75,
        height: windowHeight,
        backgroundColor: 'white',
        borderWidth: 0,
        borderTopLeftRadius: 25,
        borderBottomLeftRadius: 25,
        justifyContent: 'center',
        alignItems: 'center'
    },
    panelBoczny:{
        width: Dimensions.get('window').width*0.25,
          height: Dimensions.get('window').height,
  
          alignSelf: 'flex-start',
          
          paddingLeft: 20,
          paddingTop: 20,
         
      },
});
